export default __webpack_public_path__ + "media/images/ico/apple-icon-152-b392d2714681e653b9cf69707082b812.png";